import './EmptyState.scss';
import EmptyIllustration from 'assets/images/emptystate.png';
const defaultProps = {
	xs: {
		imageSize: '140px',
		titleSize: 14,
		descriptionSize: 10,
	},
	small: {
		imageSize: '200px',
		titleSize: 16,
		descriptionSize: 10,
	},
	medium: {
		imageSize: '300px',
		titleSize: 22,
		descriptionSize: 14,
	},
	large: {
		imageSize: '400px',
		titleSize: 26,
		descriptionSize: 16,
	},
};
function EmptyState(props) {
	return (
		<div className="EmptyState">
			<div className="Container">
				<img
					src={EmptyIllustration}
					alt="EmptyState"
					style={{ width: defaultProps[props.size || 'medium'].imageSize }}
				/>

				<div className="Description">
					<span
						className="Title"
						style={{ fontSize: defaultProps[props.size || 'medium'].titleSize }}
					>
						{props.title}
					</span>
					<span
						className="Desc"
						style={{ fontSize: defaultProps[props.size || 'medium'].description }}
					>
						{props.description}
					</span>
				</div>
			</div>
		</div>
	);
}

export default EmptyState;
